var Controller = require('controllers/base/controller');
var LocalStorageService = require('services/local-storage-service');

module.exports = Controller.extend({
  index: function() {
    var originFragment = LocalStorageService.getItem('originFragment');
    if (originFragment) {
      this.redirectTo({ url: originFragment });
    } else {
      this.redirectTo({ url: '' });
    }
    Backbone.history.start();  // stopped by navigation-service so the reload route is not in the history
    LocalStorageService.removeItem('originFragment');
  }
});
